import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-92c5564c")

_pushScopeId("data-v-92c5564c")
const _hoisted_1 = { class: "payment-method-selector-v4 flex flex-col gap-y-2" }
const _hoisted_2 = { class: "text-sm text-black-lp-300 font-semibold text-left" }
const _hoisted_3 = { class: "flex flex-row flex-nowrap gap-1.5 items-start" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col text-xs gap-1",
  style: {"line-height":"100%"}
}
const _hoisted_5 = {
  style: {"line-height":"100%"},
  class: "font-semibold text-10px"
}
const _hoisted_6 = {
  key: 0,
  class: "text-gray-lp-800 text-left font-medium",
  style: {"font-size":"10px","line-height":"100%"},
  "data-testid": "txn-booking-label-pos-limit-balance"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 0,
  class: "px-2 py-1 mt-2 bg-blue-lp-600 w-full rounded-full flex-col justify-center items-start gap-1 inline-flex"
}
const _hoisted_10 = { class: "justify-start items-center gap-2 inline-flex w-full" }
const _hoisted_11 = { class: "inline-flex text-blue-lp-700 text-10px font-medium font-montserrat" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("bookingV4.payment.title")), 1),
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paymentMethodOptions, (option) => {
        return (_openBlock(), _createBlock("div", {
          key: option.key,
          class: ["relative flex-1 min-w-0", {
          'last-payment-method': option.key === _ctx.paymentMethodKeys.INVOICE_LIMIT
        }],
          onMouseenter: ($event: any) => (_ctx.onHoverStart(option)),
          onMouseleave: ($event: any) => (_ctx.onHoverEnd(option))
        }, [
          _createVNode("button", {
            "data-testid": 
            _ctx.readonly && option.key === _ctx.paymentMethod.method
              ? 'txn-booking-label-locked-payment-method'
              : _ctx.testIdFor(option.key)
          ,
            class: ["payment-method-btn w-full justify-center", [
            { selected: option.key === _ctx.paymentMethod.method },
            { disabled: option.disabled || _ctx.isReadonly || _ctx.readonly},
            { 'readonly-mode': _ctx.isReadonly }
          ]],
            style: {"height":"36px"},
            disabled: _ctx.readonly || option.disabled,
            onClick: ($event: any) => (_ctx.selectOption(option))
          }, [
            (option.key === _ctx.paymentMethodKeys.INVOICE_LIMIT)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("bookingV4.payment.invoiceLimit")), 1),
                  (option.remainingLimit != null)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, " (" + _toDisplayString(_ctx.formattedRemainingLimit(option.remainingLimit)) + ") ", 1))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t(`bookingV4.payment.${_ctx.labelKeyFor(option.key)}`)), 1)
                ], 64))
          ], 10, ["data-testid", "disabled", "onClick"]),
          (_ctx.isHoverableKey(option.key) && _ctx.hasHoverText(option))
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                "data-testid": "txn-booking-label-payment-cod-dfod-disabled-reason",
                class: ["payment-method-hover-copy", {
            'payment-method-hover-copy--right':
              option.key === _ctx.paymentMethodKeys.DFOD &&
              _ctx.paymentMethodOptions.length < 4
          }]
              }, [
                (option.hoverCopy)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(option.hoverCopy), 1)
                    ], 64))
                  : (option.key === _ctx.paymentMethodKeys.COD)
                    ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_7, null, 512)), [
                        [_directive_sanitize_html, _ctx.$t('bookingV4.payment.tooltip.cod')]
                      ])
                    : _withDirectives((_openBlock(), _createBlock("div", _hoisted_8, null, 512)), [
                        [_directive_sanitize_html, _ctx.$t('bookingV4.payment.tooltip.dfod')]
                      ])
              ], 2))
            : _createCommentVNode("", true)
        ], 42, ["onMouseenter", "onMouseleave"]))
      }), 128))
    ]),
    (_ctx.isCodDfodDisabled)
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_Icons, {
              name: "warning-circle",
              class: "w-4 text-blue-lp-700"
            }),
            _createVNode("span", _hoisted_11, _toDisplayString(_ctx.infobarCopy), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.warningOptions, (option) => {
      return (_openBlock(), _createBlock("div", {
        key: `warning-${option.key}`,
        "data-testid": "txn-booking-label-payment-cod-dfod-warning-suspected",
        class: "payment-method-warning-copy"
      }, _toDisplayString(option.warningCopy), 1))
    }), 128))
  ]))
})